<template lang="">
  <div class="detail-view">
    <Header :nosearch="true" :title="`${stockname}-${ type === '1' ? '资讯' : type === '2' ? '公告' : '研报'}`"/>
    <div class="detail-header">
      <div class="title">
        {{detail.title}}
      </div>
      <div class="sub-media" v-if="type === '1'">
        <span style="padding-right: 10px;" v-if="detail.media && detail.media.length > 0">{{detail.media}}</span>
        <span>{{detail.pushtime}}</span>
      </div>
      <div class="sub-pdf" v-if="type === '2'">
        <span>{{detail.pushtime}}</span>
        <p v-if="detail.pdfUrl" class="pdf-btn" @click="lookpdf(detail.pdfUrl)"><i class="pdf-icon"></i>查看全文</p>
      </div>
      <div class="sub-yanbao" v-if="type === '3'">
        <template v-if="detail.content && detail.content.length > 0">
          <div>
            <span>{{detail.orgName}}</span>
            <span v-show="detail.typeName" class="sub-type">{{detail.typeName}}</span>
          </div>
          <p class="pdf-btn" @click="lookpdf"><i class="pdf-icon"></i>查看全文</p>
        </template>
        <template v-else>
          <div>
            <span>{{detail.orgName}}</span>
            <span v-show="detail.typeName" class="sub-type">{{detail.typeName}}</span>
          </div>
        </template>
      </div>
    </div>
    <div class="detail-dyna" v-show="type === '1'" @click="goHome">
      <label>{{stockname}}</label>
      <span :style="`padding-left: 10px;font-weight: 600; color: ${dyna.Updown > 0 ? color[0]: (dyna.Updown === 0 ? color[1] : color [2])}`">
        {{ !dyna.Updown ? '--' :
            dyna.Updown > 0 ? '+' + (dyna.Updown * 100).toFixed(2) + '%' : 
            dyna.Updown === 0 ? (dyna.Updown * 100).toFixed(2) + '%' : 
            (dyna.Updown * 100).toFixed(2) + '%'
          }}
      </span>
    </div>
    <div v-if="detail.content && detail.content.length > 0" class="detail-content" v-html="detail.content"></div>
    <div v-else-if="detail.rep_pdf_url" class="detail-content">
      <label>该公告为独立文件：</label>
      <div class="pdf-btn" @click="lookpdf(detail.rep_pdf_url)">点击查看PDF全文</div>
    </div>
    <div class="pdf-details-wrap" v-if="detail.pdfDetails&&detail.pdfDetails.length">
      <ul>
        <li v-for="(item, index) in detail.pdfDetails" :key="index" @click="lookpdf(item.document)">{{item.description}}({{item.size}})</li>
      </ul>
    </div>
    <div class="detail-mianze" v-if="type === '1'">
      <p>免责声明</p>
      <p>以上内容仅供用户参考和学习使用，不构成投资建议，不具有任何投资咨询信息性质，不构成对包括但不限于股票、债券、期货、期权等任何金融产品的收购、购买、认购、抛售或持有的要约邀请、要约或承诺，不能确保您获得盈利或本金不受损失，且不作为您投资的依据，您须独立作出投资决策，风险自担。投资有风险，入市需谨慎。</p>
    </div>
    <div v-if="ad" style="margin-bottom: .15rem">
      <Ad width="3.45rem" height="0.6rem" :content="ad" />
    </div>
    <div v-if="type === '1'" style="height: 0.06rem;background: #f5f5f5;"></div>

    <div class="other-list" v-if="type === '1'">
      <div class="other-title">
        推荐阅读
      </div>
      <div class="other-item" v-for="item in list.slice(0,5)" :key="item.news_id" @click="goDetail(item)">
        <p class="title">{{item.title}}</p>
        <p class="time">{{item.ctime * 1000 | showtime}}</p>
      </div>
      <!-- <infinite-loading @infinite="infiniteHandler" direction="bottom" :distance="100" :forceUseInfiniteWrapper="true">
        <div slot="no-more">无更多数据</div>
        <div slot="no-results">无咨询数据</div>
        <div slot="spinner" class="tab-spinner">正在加载...</div>
      </infinite-loading> -->
    </div>
    <a download :href="pdfUrl" ref="downloadpdf"/>
  </div>
</template>

<script>
import moment from 'moment'
import Header from '@/components/header.vue'
import {request} from '@/api/request'
import {mapState, mapMutations} from 'vuex'
import Ad from '../advertisement'

function marketTransform(val) {
  let keytmar = {
    NASDAQ: 'NASDAQ',
    nasdqa: 'NASDAQ',
    NA: 'NASDAQ',
    sh: 'sh',
    SH: 'sh',
    sz: 'sz',
    SZ: 'sz',
    HK: 'HKSE',
    hk: 'HKSE',
    hkse: 'HKSE',
    AMEX: 'AMEX',
    amex: 'amex',
    AM: 'AMEX',
    am: 'AMEX',
    HKIDX: 'HKIDX',
    hkidx: 'HKIDX'
  }
  return keytmar[val] || val.toUpperCase()
}

export default {
  data() {
    return {
      detail: {},
      type: this.$route.params.type,
      id: this.$route.params.id,
      // market: this.$route.params.market,
      // code: this.$route.params.code,
      list: [],
      pageNo: 0,
      pdfUrl: null,
      color: ['#e63535', '#0A1428', '#1BAA3C'],
      ad: null
      // stockname: ''
    }
  },
  components: {
    Header,
    Ad,
    // InfiniteLoading
  },
  computed: {
    ...mapState(['status', 'code', 'market', 'stockname', 'dyna', 'symbol'])
  },
  async created() {
    console.log(this.$route)
    this.$store.commit('setSymbol', this.$route.params)
    let stockname = await this.getStockName()
    this.$store.commit('setStockName', stockname)
    this.initData()
    this.getAd()
    window.scrollTo(0, 0)
  },
  methods: {
    ...mapMutations({
      setTabIndex: 'common/setTabIndex'
    }),
    /**
     * 获取个股名称
     */
    async getStockName () {
      let market = marketTransform(this.$store.state.market)
      let symbol = this.$store.state.code
      // if (this.$store.state.isIndex && this.$store.state.region === 'CN') market = market.toLowerCase()
      if (this.$store.state.region === 'HK') {
        symbol = symbol.length === 4 && /\d+/.test(symbol) ? '0' + symbol : symbol
      }
      if (symbol.toUpperCase() === 'BRKA' || symbol.toUpperCase() === 'BRKB') {
        symbol = 'BRK' + symbol.slice(-1).toLowerCase()
      }
      let res = await request.get({
        url: request.apis.quote.getStockName,
        params: {
          symbol,
          market,
        }
      })
      
      if (res && res.length > 0) {
        return res[0].Name
      }
    },
    async getAd() {
      const position = {
        1: 'flgmgmob_newsdetail',
        2: 'flgmgmob_reportdetail'
      }
      if(!position[this.type]) return
      let res = await request.get({
          url: request.apis.activity.activity,
          params: {
            activityStatus: 'NOW',
            hiddenStatus: 'SHOWN',
            orderBy: 'sort',
            direction: 'asc',
            position: position[this.type]
          }
        })
        this.ad = res.list[0]
    },
    goHome() {
      this.setTabIndex(0)
      this.$router.push({
        path: '/',
        query: {
          market: this.market,
          code: this.symbol
        }
      })
    },
    goDetail(zixun) {
      const {url, news_id} = zixun
      this.$router.replace(`/detail/${this.market}/${this.symbol}/1/${news_id}.html${url ? `?url=${encodeURIComponent(url)}` : ''}`, () => {
        location.reload()
      })
    },
    async initData() {
      let url = ''
      let params = {}
      switch (this.type) {
        case '1': {
          this.getListData()
          let res = await request.get({
            url: request.apis.quote.newsDetail,
            params: {
              market: (this.market === 'HKIDX' || this.market === 'hkidx') ? 'HKSE' : this.market, 
              symbol: this.symbol,
              news_id: this.id.replace(/\s/g, ''),
              url: `${this.$route.query.url}&dv=${this.$route.query.dv}`
            }
          })
          this.detail = {
            type: 1,
            title: res.title,
            media: res.media,
            pushtime: this.showtime(res.ctime * 1000),
            content: res.content.replace(/<a[\s\S]*?>([^<]*)<\/a>/gi, '$1').replace(/<img/g, '<img width="100%" ')
          }
          break;
        }
        case '2': {
          let res = await request.get({
            url: request.apis.quote.announcementDetail,
            params: {
              eventId: this.id.replace(/\s/g, ''),
              market: marketTransform(this.market)
            }
          })

          this.detail = {
            type: 1,
            title: res.eventName,
            // media: res.eventType,
            pushtime: res.eventDate,
            content: res.content ? res.content.replace(/<a[\s\S]*?>([^<]*)<\/a>/gi, '$1').replace(/<img/g, '<img width="100%" ') : null,
            pdfUrl: res.pdf_link,
            rep_pdf_url: res.pdf_url,
            pdfDetails: res.detail && res.detail.filter(item => item.document.match(/\.htm$/gi) || item.document.match(/\.txt$/gi)).map(item => ({
              description: item.description,
              document: item.document,
              size: Math.round(item.size / 1024) + 'KB'
            }))
          }
          break;
        }
        case '3': {
          let data = await request.get({
            url: request.apis.quote.detailByNewsId,
            params: {
              reportId: this.id.replace(/\s/g, ''),
              // market: this.market
            }
          })

          let res = data[0]

          this.detail = {
            type: 1,
            title: res.title,
            orgName: res.orgName,
            typeName: res.type,
            content: res.abstractreplace(/<a[\s\S]*?>([^<]*)<\/a>/gi, '$1').replace(/<img/g, '<img width="100%" '),
            pdfUrl: res.s3url,
            pushtime: this.showtime(res.publishDate)
          }
          break;
        }
        default:
          break;
      }
    },
    // async infiniteHandler($state) {
    //   let canload = await this.getListData()
    //   if (canload) $state.loaded()
    //   else $state.complete()
    // },
    /**
     * 获取list 数据
     */
    async getListData() {
      let res = await request.get({
        url: request.apis.quote.articles,
        params: {
          market: (this.market === 'HKIDX' || this.market === 'hkidx') ? 'HKSE' : this.market,
          symbol: this.symbol,
          pageNo: this.pageNo++,
          pageSize: 6,
          types: 1
        }
      })
      if (this.$route.query.url) {
        console.log('list', res.list)
        this.list = this.list.concat(res.list).filter(_ => _.url != this.$route.query.url)
      } else {
        this.list = this.list.concat(res.list).filter(_ => _.news_id != this.id)
      }
      // if (res.list && res.list.length > 0) return true
      // else return false
    },
    lookpdf(url) {
      // window.open(this.detail.pdfUrl)
      this.pdfUrl = url
      console.log(this.$refs.downloadpdf.click())
      this.$refs.downloadpdf.click()
    },
    showtime(_date) {
      let day = moment(new Date())
      let date = moment(_date)
      if (day.year() === date.year() && day.dayOfYear() === date.dayOfYear()) {
        return `${date.hour().toString().padStart(2, 0)}:${date.minute().toString().padStart(2, 0)}`
      } else if (day.year() === date.year()) {
        return `${(date.month() + 1).toString().padStart(2, 0)}-${date.date().toString().padStart(2, 0)} ${date.hour().toString().padStart(2, 0)}:${date.minute().toString().padStart(2, 0)}`
      } else {
        return `${date.year()}-${date.month() + 1}-${date.date()}`
      }
    }
  },
  filters: {
    showtime(_date) {
      let day = moment(new Date())
      let date = moment(_date)
      if (day.year() === date.year() && day.dayOfYear() === date.dayOfYear()) {
        return `${date.hour().toString().padStart(2, 0)}:${date.minute().toString().padStart(2, 0)}`
      } else if (day.year() === date.year()) {
        return `${(date.month() + 1).toString().padStart(2, 0)}-${date.date().toString().padStart(2, 0)} ${date.hour().toString().padStart(2, 0)}:${date.minute().toString().padStart(2, 0)}`
      } else {
        return `${date.year()}-${date.month() + 1}-${date.date()}`
      }
    },
  }
}
</script>

<style lang="stylus" scoped>
.detail-view
  background #fff
  margin-top 0.4rem
  min-height 100vh
  .detail-dyna
    padding 8px 0
    margin 0 12px
    border-top 1px solid #f5f5f5
    border-bottom 1px solid #f5f5f5
  .pdf-details-wrap
    padding-top 0.09rem
    ul
      li
        margin 0.2rem auto 
        background #409AFB
        color white
        font-size .15rem
        text-align center
        width 2.7rem
        height .35rem
        line-height .35rem
        white-space: nowrap
        text-overflow: ellipsis
        overflow: hidden
        padding 0 .1rem
  .detail-header
    padding 12px 0 0 0
    margin 0 12px
    border-bottom 0.5px solid #F5F5F5
    .title
      font-size 17px
      color #1f2126
      font-weight 600
    .sub-media
      color #999999
      font-size 12px
      padding 6px 0
    .sub-yanbao
      color #999999
      font-size 12px
      padding 6px 0
      display flex
      justify-content space-between
      align-items center
      .sub-type
        border 1px solid rgb(64, 154, 251)
        color rgb(64, 154, 251)
        padding 2px
        font-size 10px
        margin-left 8px
    .sub-pdf
      display flex
      font-size 12px
      color #999
      align-items center
      justify-content space-between
      padding 7px 0 21px 0
    .pdf-btn
      width 102px
      height 26px
      background #409afb
      font-size 12px
      color #fff
      display flex
      align-items center
      justify-content center
    .pdf-icon
      background url('../../assets/pdfbtn.png')
      width 16px
      height 20px
      background-size contain
      display block
      margin-right 6px
  .detail-content
    padding 10px 0
    margin 0 12px
    font-size 15px
    color #1f2126
    overflow scroll
    .pdf-btn
      text-align center
      margin 20px auto
      width 200px
      height 30px
      line-height 30px
      background #409afb
      // font-size 12px
      color #fff
  .detail-mianze
    font-size 12px
    color #bbb
    margin  20px 12px 15px 12px
    padding 10px 12px
    background #FAFAFA
  .other-list
    margin 0 12px
    .other-title
      font-size 15px
      height 21px
      font-weight 600
      line-height 21px
      border-bottom 1px solid #edeff3
      padding 13px 0 6px 0
    .other-item
      padding 9px 0
      border-bottom 1px solid #f5f5f5
      .title
        color #333
        font-size 15px
        font-weight 400
      .time
        color #999
        font-size 12px
</style>

<style lang="stylus">
.article-img {
  max-width: 100%
}
</style>